import { CellContext, Row, SortingFn } from "@tanstack/react-table";
import { compareAlphanumeric } from "../../../utils/sorting";

const filterNumberColumn = <TData,>(row: Row<TData>, columnId: string, filterValue: [string, string]): boolean => {
    const value = row.getValue(columnId) as number | null;

    // If filter is empty, all rows are displayed
    if (!filterValue || (filterValue[0] === "" && filterValue[1] === "")) {
        return true;
    }

    // If filter is not empty but cell value is null, this value shouldn't be displayed
    if (value === null) {
        return false;
    }

    const [min, max] = filterValue;

    if (min !== "" && value < +min) {
        return false;
    }

    if (max !== "" && value > +max) {
        return false;
    }

    return true;
};

export const createNumberColumn = <TData,>(
    id: string,
    header: string,
    accessorKey: keyof TData,
    isInteger?: boolean,
) => ({
    id,
    header,
    accessorKey,
    cell: ({ getValue }: CellContext<TData, number | null>) => {
        const value = getValue();

        if (value === null || value === undefined) {
            return "-";
        }

        if (isInteger) {
            return <span>{value}</span>;
        }

        return <span title={value.toString()}>{value.toFixed(1)}</span>;
    },
    filterFn: filterNumberColumn<TData>,
    meta: {
        filterVariant: "range",
    },
});

export const compareColumnAlphanumeric =
    <TData,>(): SortingFn<TData> =>
        (rowA: Row<TData>, rowB: Row<TData>, columnId: string) => {
            return compareAlphanumeric(rowA.getValue(columnId), rowB.getValue(columnId));
        };
